<script setup lang="ts">
import type { Status } from '@/interfaces/Dashboard';

defineProps<{
  status: Status;
  title: string;
  value: string | number;
}>();

const dangerStyles = {
  borderLeft: 'tw-border-l-connx-danger',
  text: 'tw-text-connx-danger',
  bgTint: 'tw-bg-connx-danger-tint-95',
};

const statusClasses: Record<
  Status,
  {
    borderLeft: string;
    text: string;
    bgTint: string;
  }
> = {
  success: {
    borderLeft: 'tw-border-l-connx-success',
    text: 'tw-text-connx-success',
    bgTint: 'tw-bg-connx-success-tint-95',
  },
  warning: {
    borderLeft: 'tw-border-l-connx-warning',
    text: 'tw-text-connx-warning',
    bgTint: 'tw-bg-connx-warning-tint-95',
  },
  danger: dangerStyles,
  error: dangerStyles,
  info: {
    borderLeft: 'tw-border-l-connx-info',
    text: 'tw-text-connx-info',
    bgTint: 'tw-bg-connx-info-tint-95',
  },
};
</script>
<template>
  <div class="tw-flex tw-flex-col tw-gap-4">
    <div
      class="tw-flex tw-justify-between tw-items-center tw-border-4 tw-border-solid tw-border-t-0 tw-border-r-0 tw-border-b-0 tw-pl-2 tw-pr-4 tw-rounded-r-md"
      :class="[statusClasses[status].borderLeft, statusClasses[status].bgTint]"
    >
      <div class="tw-text-sm tw-text-connx-grey-shade-55 tw-ml-1">
        {{ title }}
      </div>
      <div
        class="tw-text-base tw-font-bold tw-text-center tw-whitespace-nowrap tw-w-fit"
        :class="statusClasses[status].text"
      >
        {{ value }}
      </div>
    </div>
  </div>
</template>
